import React, { useState, useCallback, useEffect } from "react";
import './App.css';
import { List, Table } from "antd";
import { isTimeframeActive } from "./utils/timeframeUtils";
import { useContext } from "react";
import AuthContext from "./contexts/Authentication";
import useGetMyPortfolios from "./hooks/useGetMyPortfolios";
import { Link } from "react-router-dom";

const UserPortsSidebar = (props) => {

  const getMyPortfolios = useGetMyPortfolios();

  const [isErr,setIsErr] = useState(false);
  const [portData,setPortData] = useState([]);
  const {auth} = useContext(AuthContext);



    const getMyPortfolioInfo = useCallback(async() => {
      if (!auth?.user){
        console.log("not logged in for port sidebar")
        return;
      }
      try {
        //setIsSubmitting(true);
        const data = await getMyPortfolios();
        console.log(data);
        console.log("User has " + data.length + " portfolios");
        const currData = [];
        for (const port of data){
          if (isTimeframeActive(port.timeframe)){
            currData.push(port);
          }
        }
        setPortData(currData.sort( (a,b) => (b.timeframe - a.timeframe)));
        /*const portOptions = currData.map( (port) => (
          {
            value: port.port_id,
            label: port.port_name,
            timeframe: port.timeframe,
            key: port.port_id
            //port_type: port.port_type
          }
  
        ))*/

        //console.log(portOptions);
        //setPortNames(portOptions);
        //setIsSubmitting(false);
      }
      catch (err) {
        console.log(err);
        setIsErr(true);
        //setIsSubmitting(false);
        return err;
      }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
  
    useEffect( () => {
      getMyPortfolioInfo();
    }, [getMyPortfolioInfo]);

    const columns = [
        {
          //title: "Portfolio Name",
          title: "Your Portfolios",
          dataIndex: "port_name",
          key: "name"
          ,
          render : (text,record) => (
            <Link to={"/portfolio/" + record.key}>{record.port_name}</Link>
          )
        },

        {
          title: "Worth",
          dataIndex: "worth",
          key: "worth",
          render : (text) => (
            "$"+ text
          )
        },
        /*{
          title: "League",
          dataIndex: "league_name",
          key: "league_name"
          ,
          render : (text,record) => (
            record.league_count > 0
            ?
              record.league_count ===1
              ?
                <Link to={"/league/" + record.league_id}>{record.league_name}</Link>
              :
              "Multiple"
            :
              "None"
          )
        }, */
      ]


  return (
    <div>
    {/*<div class="module-header">
        <header class="module-list content">
            <h2>Site News</h2>
        </header>
        <ul class="module-list content">{data[0]}</ul>
    </div> */}
    <div>
    {portData.length>0 && !isErr &&
      <Table size="small"
        //title = {()=>"Your Portfolios"}
        bordered
        dataSource={portData}
        columns={columns}
        pagination={{position:["none"]}} //changes to pagination={{placement:["none"]}} at antd v5.x
        renderItem={(item) => <List.Item>{item}</List.Item>}>
      </Table>}
    </div></div>
  );
}

export default UserPortsSidebar;
